import { render, staticRenderFns } from "./dashboardLeaveBalances.vue?vue&type=template&id=76c5e8af"
import script from "./dashboardLeaveBalances.vue?vue&type=script&lang=js"
export * from "./dashboardLeaveBalances.vue?vue&type=script&lang=js"
import style0 from "./dashboardLeaveBalances.vue?vue&type=style&index=0&id=76c5e8af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports